import { render, staticRenderFns } from "./PointsAccounts.vue?vue&type=template&id=741131d9&scoped=true"
import script from "./PointsAccounts.vue?vue&type=script&lang=js"
export * from "./PointsAccounts.vue?vue&type=script&lang=js"
import style0 from "./PointsAccounts.vue?vue&type=style&index=0&id=741131d9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741131d9",
  null
  
)

export default component.exports